require("./aresLoansConfirmationView.scss");

const PropTypes = require("prop-types");

// @vendor
const React = require("react");
const { connect } = require("react-redux");
const { withRouter } = require("react-router-dom");
// @actions
const { retrieveAresDossier } = require("../../actions/aresDossier");
// @commons
const { OKCover } = require("commonsComponents/OKCover");
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");
const { OKSectionBox } = require("commonsComponents/OKSectionBox");
const { OKButton } = require("commonsComponents/OKButton");
// @constants
const {
    NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES,
} = require("constants/flagBasedFeatures");
const dossierStatus = require("../../loansConstants/dossierStatus");
const {
    PAGE_ARES_LOANS_CONFIRMATION,
    recordLink,
    recordLinkV2,
} = require("utilities/tagging");
const { analyticsId, catalogue } = require( "../../components/contracts/contractAresLoan/analytics/contractAresLoanAnalytics" );
//@core
const { formatText } = require("core/i18n").i18n;

const ARES_CONTEXT = "aresLoan-";
const BASE_CONTEXT = `${ARES_CONTEXT}mbBanking.products.loansAndMortgages.productContracting.success_LoanContracting.`;

class AresLoansConfirmationView extends React.Component {
    constructor(props) {
        super(props);

        this.handleBack = this.handleBack.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures, immAresDossier, retrieveAresDossier } =
            this.props;
        if (
            !immFlagBasedFeatures.get(
                NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES
            )
        ) {
            this.props.history.push('/myprofile/loans-mortgages');
        } else if (!immAresDossier.get("dossier")) {
            retrieveAresDossier();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immAresDossier } = nextProps;
        const dossier = immAresDossier.get("dossier");

        if (
            dossier !== null &&
            dossier.get("status") !== dossierStatus.WAIT_DOCUMENTS
            ) {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }

    handleBack() {
        recordLink(PAGE_ARES_LOANS_CONFIRMATION, "volver a posicion global");
        this.props.history.push('/myprofile/global');
    }

    buildBreadcrumbConfig() {
        return [
            {
                text: formatText("breadcrumb-loansAndMortgages"),
                url: "/myprofile/loans-mortgages",
                onLinkClick: () => recordLinkV2(catalogue[analyticsId.CLICK_BREADCRUMB_01]()),
            },
            {
                text: formatText("breadcrumb-payrollLoanContract"),
            },
        ];
    }

    buildContent() {
        return (
            <div className="col-xs-12">
                <OKSectionBox
                    title={formatText(
                        `${BASE_CONTEXT}mbConfirmationOperativeHeader`
                    )}
                    icon="success"
                >
                    <div className="ok-section-box__main">
                        <div className="ok-section-box__sub-title">
                            {formatText(`${BASE_CONTEXT}mbConfirmationOperativeHeader.successSubtitle`)}
                        </div>
                        {formatText(
                            `${BASE_CONTEXT}mbConfirmationOperativeHeader.successDescription`
                        )}
                    </div>
                    <div className="ok-section-box__footer">
                        <OKButton
                            modifier="link-complementary"
                            onClick={this.handleBack}
                        >
                            {formatText(
                                `${BASE_CONTEXT}mbLoanContracting.navigationReturnToGlobalPositionLink`
                            )}
                        </OKButton>
                    </div>
                </OKSectionBox>
            </div>
        );
    }

    buildHeader() {
        const breadcrumb = this.buildBreadcrumbConfig();

        return (
            <OKCover
                size="medium"
                section="generic"
                customClass="ares-loans-confirmation-view__header"
            >
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumb}
                    finalTitle={formatText(
                            `${BASE_CONTEXT}mbLoanContracting.header`
                        )}
                    />
            </OKCover>
        );
    }

    render() {
        const header = this.buildHeader();
        const content = this.buildContent();

        return (
            <article className="ares-loans-confirmation-view">
                {header}
                <section className="ares-loans-confirmation-view__body">
                    {content}
                </section>
            </article>
        );
    }
}

AresLoansConfirmationView.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    retrieveAresDossier: PropTypes.func.isRequired,
    immAresDossier: PropTypes.object,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(connect(
    (state) => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immAresDossier: state.aresDossier,
    }),
    {
        retrieveAresDossier: retrieveAresDossier,
    }
)(AresLoansConfirmationView));
